// apiNode.js

import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const APINode = ({ id, data }) => {
    const [endpoint, setEndpoint] = useState(data?.endpoint || 'https://api.example.com');
    const [method, setMethod] = useState(data?.method || 'GET');

    return (
        <BaseNode
            id={id}
            title="API Node"
            handles={[
                { type: 'target', position: Position.Left, id: `${id}-trigger` },
                { type: 'source', position: Position.Right, id: `${id}-response` }
            ]}
        >
            <label style={{ display: 'flex', flexDirection: 'column', fontSize: '12px' }}>
                Endpoint:
                <input
                    type="text"
                    value={endpoint}
                    onChange={(e) => setEndpoint(e.target.value)}
                    style={{ marginTop: '4px' }}
                />
            </label>
            <label style={{ display: 'flex', flexDirection: 'column', fontSize: '12px', marginTop: '4px' }}>
                Method:
                <select value={method} onChange={(e) => setMethod(e.target.value)} style={{ marginTop: '4px' }}>
                    <option value="GET">GET</option>
                    <option value="POST">POST</option>
                    <option value="PUT">PUT</option>
                </select>
            </label>
        </BaseNode>
    );
}
